import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

import Vuelidate from 'vuelidate';

import i18n from './i18n/i18n';

import './assets/css/custom.scss';
import {
	AlertPlugin,
	BadgePlugin,
	ButtonPlugin,
	CardPlugin,
	CollapsePlugin,
	FormGroupPlugin,
	FormInputPlugin,
	FormPlugin,
	FormSelectPlugin,
	FormTextareaPlugin,
	FormFilePlugin,
	LayoutPlugin,
	ListGroupPlugin,
	ModalPlugin,
	NavbarPlugin,
	PaginationPlugin,
	TablePlugin,
	TooltipPlugin,
	LinkPlugin,
	FormCheckboxPlugin,
	SpinnerPlugin,
	ToastPlugin,
	InputGroupPlugin,
	ProgressPlugin,
	TabsPlugin,
	FormTimepickerPlugin,
	FormDatepickerPlugin,
} from 'bootstrap-vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faArrowLeft,
	faBars,
	faChevronDown,
	faExclamationTriangle,
	faTimes,
	faExclamation,
	faPlus,
	faMinus,
} from '@fortawesome/free-solid-svg-icons';
import {
	FontAwesomeIcon,
	FontAwesomeLayers,
	FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import VueCookies from 'vue-cookies';

import {
	LMap,
	LMarker,
	LImageOverlay,
	LControl,
	LControlZoom,
	LTooltip,
	LRectangle,
} from 'vue2-leaflet';
import LControlFullscreen from 'vue2-leaflet-fullscreen';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.heat';
import 'leaflet-path-drag';

import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';

import JsonExcel from 'vue-json-excel';

Vue.use(AlertPlugin);
Vue.use(LayoutPlugin);
Vue.use(ButtonPlugin);
Vue.use(FormPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormSelectPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormFilePlugin);
Vue.use(NavbarPlugin);
Vue.use(CardPlugin);
Vue.use(ListGroupPlugin);
Vue.use(NavbarPlugin);
Vue.use(BadgePlugin);
Vue.use(TablePlugin);
Vue.use(PaginationPlugin);
Vue.use(ModalPlugin);
Vue.use(TooltipPlugin);
Vue.use(CollapsePlugin);
Vue.use(LinkPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(SpinnerPlugin);
Vue.use(InputGroupPlugin);
Vue.use(ToastPlugin);
Vue.use(ProgressPlugin);
Vue.use(TabsPlugin);
Vue.use(FormDatepickerPlugin);
Vue.use(FormTimepickerPlugin);

library.add(
	faExclamationTriangle,
	faChevronDown,
	faBars,
	faArrowLeft,
	faTimes,
	faExclamation,
	faPlus,
	faMinus
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

Vue.component('l-map', LMap);
Vue.component('l-marker', LMarker);
Vue.component('l-image-overlay', LImageOverlay);
Vue.component('l-control-zoom', LControlZoom);
Vue.component('l-control', LControl);
Vue.component('l-tooltip', LTooltip);
Vue.component('l-rectangle', LRectangle);
Vue.component('l-control-fullscreen', LControlFullscreen);
Vue.component('downloadExcel', JsonExcel);

Vue.component('VueSlider', VueSlider);

type D = Icon.Default & {
	_getIconUrl?: string;
};

delete (Icon.Default.prototype as D)._getIconUrl;
Icon.Default.mergeOptions({
	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
	iconUrl: require('leaflet/dist/images/marker-icon.png'),
	shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.use(Vuelidate);
Vue.use(VueCookies);

if (process.env.VUE_APP_LOCAL_NETWORK === 'true') {
	Vue.$cookies.config('4h', '', '', false, 'Strict');
} else {
	Vue.$cookies.config('4h', '', '', process.env.NODE_ENV === 'production', 'Strict');
}

Vue.config.productionTip = process.env.NODE_ENV === 'development';

new Vue({
	i18n,
	store,
	router,
	render: (h) => h(App),
}).$mount('#app');
